module.exports = __webpack_public_path__ + "img/repeat-01.57fa3513.svg";